import { faXmark } from "@fortawesome/pro-light-svg-icons";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";
import { rightSidePaneWidthClassname } from "src/flowContainer/RightPane";

type SubPaneLayoutProps = {
  children: React.ReactNode;
  onBackButtonClick: () => void;
  onCloseButtonClick: () => void;
  title: string;
};

export const SubPaneLayout: React.FC<SubPaneLayoutProps> = ({
  children,
  onBackButtonClick,
  onCloseButtonClick,
  title,
}) => {
  return (
    <div className={twJoin("bg-white px-4 pt-4", rightSidePaneWidthClassname)}>
      <div className="mb-4 flex flex-row items-center justify-between text-gray-800">
        <div className="flex">
          <Icon
            color="text-gray-500 hover:text-gray-700 hover:cursor-pointer"
            icon={faArrowLeft}
            size="xs"
            onClick={onBackButtonClick}
          />
          <div className="ml-2 font-inter-semibold-16px">{title}</div>
        </div>
        <Icon
          color="text-gray-500 hover:text-gray-700 hover:cursor-pointer"
          icon={faXmark}
          size="xs"
          onClick={onCloseButtonClick}
        />
      </div>
      {children}
    </div>
  );
};
